export default __webpack_public_path__ + "static/media/Omb03.feedf04d.png";